/**
 * Zentrale Abfrage, ob Bewegung unterdrückt werden soll: entweder weil der
 * kontrastarme Modus aktiv ist (<html class="contrast-reduced">) oder weil das
 * Betriebssystem "prefers-reduced-motion: reduce" meldet.
 */
const reducedMotionActive = () => {
  try {
    if (document.documentElement.classList.contains('contrast-reduced')) return true;
  } catch (e) {
    /* noop */
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export default reducedMotionActive;
